<int-integrators-details
    [integrationName]="integrationName"
    [integrationType]="integrationType"
    [creating]="creating"
    [user]="user"
    [invites]="invites"></int-integrators-details>

<div mat-dialog-content>
  <div *ngIf="isAdmin && !creating && existingIntegrations.length > 0 && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div>
    <h4>Advocado FTP Guide</h4>
    <p>Advocado hosts an sftp server located at: <a href="sftp://sftp.myadvocado.com">sftp.myadvocado.com</a></p>
    <p>
      You can access the server by connecting on port 22 using a software package like Filezilla or Cyberduck.
      The username and password you use to login to the Advocado Web Portal will grant you access to your
      organization's FTP locations.
    </p>
    <p>
      Locations defined below will become available as Destinations for Scheduled Reports.
    </p>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Locations</h4>
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      Add FTP Location
    </button>
  </div>

  <div *ngIf="!creating">
    <div *ngFor="let int of existingIntegrations">Name: {{int.friendlyName}}, Location: {{ int.location }}</div>
  </div>

  <form #ftpForm="ngForm" fxLayout="column" *ngIf="creating">
    <div fxLayout="column" class="mx-2" fxLayoutAlign="center">
      <mat-form-field>
        <input
            matInput
            #name="ngModel"
            placeholder="Friendly Name"
            [(ngModel)]="int.friendlyName"
            name="name"
            required
        />
        <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
          <div *ngIf="name.errors.required">Friendly Name is required</div>
        </mat-error>
      </mat-form-field>


      <mat-form-field>
        <input
            matInput
            [ftpDuplicate]="locationToVerify"
            (keyup)="locationKeyupHandler(int.location)"
            (blur)="locationBlurred(int.location)"
            #location="ngModel"
            placeholder="Location"
            [(ngModel)]="int.location"
            name="location"
            required
        />
        <mat-error *ngIf="location.invalid && (location.dirty || location.touched)">
          <div *ngIf="location.errors.required">Location is required</div>
          <div *ngIf="!ftpValidationError && location.errors.ftpDuplicate">Location is already in use</div>
          <div *ngIf="ftpValidationError">{{ftpValidationError}}</div>
        </mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="end end">
      <button mat-button mat-dialog-close>CANCEL</button>
      <button
          [appShowSpinner]="loading"
          [buttonText]="'Create'"
          class="save-button"
          mat-raised-button
          color="primary"
          [disabled]="preventSubmit || !ftpForm.form.valid"
          (click)="create($event)"
      >
        CREATE
      </button>
    </div>
  </form>
</div>
<div *ngIf="!creating" align="end">
  <button mat-button mat-dialog-close>CANCEL</button>
</div>